import { render, staticRenderFns } from "./RegionsBar.vue?vue&type=template&id=470157a8&scoped=true&"
import script from "./RegionsBar.vue?vue&type=script&lang=js&"
export * from "./RegionsBar.vue?vue&type=script&lang=js&"
import style0 from "./RegionsBar.vue?vue&type=style&index=0&id=470157a8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "470157a8",
  null
  
)

export default component.exports